// 新聞頁 側邊 top 新聞 元件
import Link from "next/link";
import Image from "next/image";

const TopNewsComponent = ({ news, i }) => {
  return (
    <Link
      href={`/news/${news?.slug}`}
      className={`group py-[12px] between-center w-full gap-x-[14px]
      ${i === 4 ? "" : "border-b-1 border-black2 border-opacity-[.5]"}`}
      prefetch={false}
    >
      {/* 新聞圖片 */}
      <div className="img-box w-[78px] h-[67px] rounded-[2px] overflow-hidden flex-shrink-0">
        <Image
          className="hover-img"
          width={78}
          height={67}
          sizes="100px"
          src={
            news?.image || news?.imageFb || "/images/news/default_related.svg"
          }
          alt={news?.brief || "news_image"}
        />
      </div>

      <h3 className="hover-text flex-grow text-bd1m text-black9 line-clamp-2 lighten-text">
        {news?.title}
      </h3>
    </Link>
  );
};

export default TopNewsComponent;
